import { DateField, useTranslate } from "react-admin";
import {
  Group,
  GroupTitle,
  LongTextField,
  ReferenceListField,
} from "ra-friendsofbabba";

import React from "react";
import DocsField from "../../technical-report-replies/fields/DocsField";
import MessageField from "../../technical-report-replies/fields/MessageField";

const RepliesField = ({ tab = 6, ...props }) => {
  const translate = useTranslate();
  return (
    <Group wrapper>
      <GroupTitle
        title={translate(props?.source)}
        subTitle={translate("resources.technical-reports.fields.replies.help")}
      />

      <ReferenceListField
        {...props}
        tab={tab}
        perPage={10}
        reference="technical-report-replies"
        target="technical_report_id"
        sort={{ field: "created", order: "desc" }}
        create={true}
        modify={false}
        remove={false}
        addLabel={false}
        createLabel="ra.action.add-replie"
        mobilePrimaryText="user.name"
        mobileSecondaryText="message"
        mobileBreakpoint="xs"
      >
        <LongTextField source="user.name" sortable={false} />
        <MessageField source="message" variant="body2" sortable={false} />
        <DocsField source="doc_media" />
        <DateField source="created" showTime />
      </ReferenceListField>
    </Group>
  );
};

export default RepliesField;
